import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import { resetPassword } from "services/users";
import { t } from "i18next";

export default function ResetPassword() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(resetPassword, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            message: t("profile_updated_successfully"),
          });
          queryClient.invalidateQueries("CurrentUser");
        }
      },
    }),
  };
}
